<template>
  <div
    class="d-flex flex-column justify-content-center"
    :class="divClass"
    :style="divStyle"
  >
    <div class="text-center spinner-container" v-if="loading">
      <vue-lottie
        v-if="loading"
        :options="spinnerAnimationOptions"
        class="blue-filter"
        text
      ></vue-lottie>
    </div>

    <input
      ref="fileInput"
      @change="tratarArquivo"
      class="form-control mb-1"
      type="file"
      :state="false"
      :disabled="!normaOcrArquivo"
      accept=".png,.jpg,.jpeg,.pdf,.PNG,.JPG,.JPEG,.PDF,.doc,.docx,.DOC,.DOCX"
    />
    <img
      v-if="isImage"
      :src="arquivo.comprovante"
      :class="{ 'blurred-image': loading, 'div-clickable': true }"
      :style="imageStyle"
      @click="singleImage = true"
    />
    <vue-easy-lightbox
      :visible="singleImage"
      :imgs="arquivo.comprovante"
      @hide="singleImage = false"
    ></vue-easy-lightbox>
    <PDFViewer v-if="isPdf && arquivo.tipoComprovante === 'PDF'" :source="arquivo.comprovante" :style="embedStyle" />
    <embed v-if="isPdf && arquivo.tipoComprovante === 'pdf'" :src="arquivo.comprovante" :style="embedStyle"/>
    <div v-else-if="isWord" class="text-center mt-3">
      <i class="fas fa-file-word fa-3x text-primary mb-2"></i>
      <div>Documento Anexado</div>
      <div class="mt-1 fw-bold">{{ previousFile ? previousFile.name : '' }}</div>
    </div>
    <template>
      <div class="tooltip-container col-md-12">
        <a @click="abrirModalPrincipios">
          <i class="fas fa-question-circle interrogacao"></i>
        </a>
        <span class="ocr" v-if="normaOcrArquivo === 'S'">OCR</span>
        <div class="custom-tooltip" v-if="normaOcrArquivo === 'S'">
          O OCR tentará extrair e preencher os campos baseado no comprovante
        </div>

        <b-modal
          v-model="mostrarModalPrincipios"
          id="modalImagem"
          title="7 Principios"
          hide-footer
        >
          <img src="@/assets/images/principios.png" alt="Imagem" />
        </b-modal>
      </div>
    </template>
  </div>
</template>

<script>
import VueEasyLightbox from "vue-easy-lightbox";
import { handleImagemOcr } from "../../../store/ocr.js";
import { BTooltip } from "bootstrap-vue";
import spinnerAnimationData from "../../../assets/images/animacao-ocr.json";
import VueLottie from "vue-lottie";
import PDFViewer from 'pdf-viewer-vue/dist/vue2-pdf-viewer'


export default {
  components: {
    VueEasyLightbox,
    PDFViewer
  },

  BTooltip,
  VueLottie,

  props: {
    normaOcrArquivo: String,
    rdvInfo: Object,
    status: {
      type: String,
    },
  },

  data() {
    return {
      singleImage: false,
      loading: false,
      arquivo: {
        tipoComprovante: "",
        comprovante: "",
        trocarImg: false,
      },
      mostrarModalPrincipios: false,
      spinnerAnimationOptions: {
        animationData: spinnerAnimationData,
        loop: true,
        autoplay: true,
        width: "",
      },
      validateArquivo: false,
      previousFile: null,
    };
  },

  computed: {
    divClass() {
      return this.validateArquivo ? "div-file-error" : "div-file";
    },

    divStyle() {
      return { height: "500px" };
    },

    isStatusV() {
      return this.status === "V";
    },

    isImage() {
      return (
        this.arquivo.tipoComprovante &&
        ["jpg", "jpeg", "png", "webp"].includes(this.arquivo.tipoComprovante.toLowerCase())
      );
    },

    isPdf() {
      return (
        this.arquivo.tipoComprovante && this.arquivo.tipoComprovante.toLowerCase() === "pdf"
      );
    },

    isWord() {
      if (
        this.arquivo.tipoComprovante &&
        ["doc", "docx"].includes(this.arquivo.tipoComprovante.toLowerCase())
      ) {
        this.$tools.alerta("Documento anexado com sucesso!", "success");
        return true;
      }
      return false;
    },

    imageStyle() {
      return { height: "85%", width: "70%" };
    },

    embedStyle() {
      return { height: "85%", width: "95%" };
    },
  },

  methods: {
    abrirModalPrincipios() {
      this.mostrarModalPrincipios = true;
    },

    async tratarArquivo(event) {
      try {
        //Inicializa o loading
        this.loading = true;

        //Pega o arquivo
        const file = this.getFileFromEvent(event);
        if (!file) return;

        //Pega a extensão do arquivo
        this.arquivo.tipoComprovante = this.getFileExtension(file);

        //Verifica se a extensão é válida
        if (!this.isExtensionValid(this.arquivo.tipoComprovante)) return;

        //Lê e analisa a imagem
        await this.readAndAnalyzeImage(file);

        if (this.arquivo.tipoComprovante.toLowerCase() === "pdf") {
          this.arquivo.pdf = URL.createObjectURL(file);
        }

        if (this.isWord) {
          this.arquivo.comprovante = URL.createObjectURL(file);
        }

        const file2 = event.target.files[0];
        if (this.previousFile && this.previousFile.name === file2.name) {
          this.$tools.alerta(
            "Atenção: Você já selecionou esse arquivo!",
            "warning"
          );
        }
        // Continue com o processamento do arquivo
        this.previousFile = file2;

        // Limpar o campo de arquivo
        this.$refs.fileInput.value = "";

        this.arquivo.trocarImg = true;
      } catch (error) {
        this.arquivo.trocarImg = false;
        console.error("Erro na solicitação:", error);
      }
    },

    getFileFromEvent(event) {
      const file = event.target.files || event.dataTransfer.files;
      return file.length ? file[0] : null;
    },

    getFileExtension(file) {
      return file.name.substring(file.name.lastIndexOf(".") + 1);
    },

    isExtensionValid(extension) {
      const allowedExtensions = "png jpg jpeg pdf webp doc docx";
      extension = extension.toLowerCase();
      if (!allowedExtensions.includes(extension)) {
        this.$tools.alerta(
          "Extensão Inválida, verifique seu arquivo e tente novamente!",
          "error"
        );
        this.$refs.fileInput.value = "";
        this.loading = false;
        return false;
      }
      return true;
    },

    async readAndAnalyzeImage(file) {
      const reader = new FileReader();
      reader.onloadend = async (e) => {
        this.arquivo.comprovante = e.target.result;
        try {
          await this.setArquivo(this.arquivo);
        } catch (error) {
          console.error("Erro na solicitação:", error);
          this.$tools.alerta("Erro ao carregar imagem", "error");
        } finally {
          this.loading = false;
        }
      };
      reader.readAsDataURL(file);
    },

    validate(param) {
      this.validateArquivo = param;
    },

    // async setArquivo(param) {
    //   try {
    //     this.arquivo = param;
    //     if (this.normaOcrArquivo === "S") {
    //       //verifica se a norma é um ocr
    //       const ocrData = await this.handleImageOcr(param.comprovante);
    //       this.$emit("enviar-ocr-data", ocrData, { arquivo: this.arquivo });
    //       this.$emit("image-loaded", true);
    //     } else {
    //       //Libera os campos para edição
    //       this.$emit("trocar-img", this.arquivo.trocarImg);
    //       this.$emit("image-loaded", true);
    //       this.$emit("enviar-ocr-data", false, { arquivo: this.arquivo });
    //     }
    //   } catch (error) {
    //     this.$emit("image-loaded", false);
    //     this.$emit("enviar-ocr-data", false, { arquivo: this.arquivo });
    //     console.error("Erro na solicitação:", error);
    //     this.$tools.alerta(
    //       "Não foi possível carregar imagem, tente enviar um arquivo menor.",
    //       "warning"
    //     );
    //   }
    // },

    async setArquivo(param) {
      try {
        // Só valida tamanho se for um File/Blob
        if (param.comprovante && param.comprovante.size) {
          const fileSize = param.comprovante.size / (1024 * 1024);
          const maxFileSize = 1;
          if (fileSize > maxFileSize) {
            this.$tools.alerta(
              `O arquivo é muito grande. Por favor, envie um arquivo menor que ${maxFileSize}MB.`,
              "warning"
            );
            return;
          }
        }

        this.arquivo = param;
        if (this.normaOcrArquivo === "S") {
          const ocrDataPromise = this.handleImageOcr(param.comprovante);
          const timeoutPromise = new Promise((_, reject) =>
            setTimeout(
              () =>
                reject(
                  new Error(
                    "Processo de leitura do OCR muito longo. Revise a imagem e tente novamente."
                  )
                ),
              20000
            )
          );
          try {
            const ocrData = await Promise.race([
              ocrDataPromise,
              timeoutPromise,
            ]);

            // Só emite os dados se salvou com sucesso
            this.$emit("enviar-ocr-data", ocrData, { arquivo: this.arquivo });
            this.$emit("image-loaded", true);
          } catch (error) {
            this.showDiv = true;
            this.$emit("trocar-img", this.arquivo.trocarImg);
            this.$emit("image-loaded", true);
            this.$emit("enviar-ocr-data", { error: true }, { arquivo: this.arquivo });
            this.$tools.alerta(error, "warning");
          }
        } else {
          this.$emit("trocar-img", this.arquivo.trocarImg);
          this.$emit("image-loaded", true);
          this.$emit("enviar-ocr-data", false, { arquivo: this.arquivo });
        }
      } catch (error) {
        this.$emit("image-loaded", false);
        this.showDiv = true;
        console.error("Erro na solicitação:", error);
        this.$tools.alerta(
          "Não foi possível carregar imagem, tente outro comprovante.",
          "warning"
        );
      }
    },

    // Função assíncrona para processar a imagem com OCR
    async handleImageOcr(image) {
      return await handleImagemOcr(image);
    },
  },
};
</script>
<style>
.blurred-image {
  filter: blur(5px);
  /* Ajuste o valor do desfoque conforme necessário */
}

.spinner-container {
  position: absolute;
  z-index: 1000;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  font: 50px;
}

.interrogacao {
  font-size: 20px;
  cursor: pointer;
}

.modal-body img {
  width: 100% !important;
}

.tooltip-container {
  display: flex;
  align-items: center;
  justify-content: end;
}

.tooltip-container a {
  margin-right: 10px;
  /* Ajuste o espaçamento conforme necessário */
}

.ocr {
  color: blue;
  padding: 5px;
  border: 1px solid blue;
  border-radius: 27%;
}

.custom-tooltip {
  display: none;
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 5px;
  border-radius: 3px;
  bottom: 30px;
  right: 0;
  white-space: nowrap;
}

.ocr:hover + .custom-tooltip {
  display: block;
}

</style>
